<template>
  <!--
    모바일 상단 햄버거 바.

    폰에서는 하단 탭만 두기로 해서 렌더하지 않는다(v-if="false").
    코드는 지우지 않고 남긴다 — CSS(sidenavbar.scss 의 .mobile-header /
    #new-sidenav.active)와 토글 JS(menuBtnFunction)도 그대로 있어서,
    방침이 바뀌면 이 조건만 되돌리면 다시 동작한다.

    폰의 상단 바는 App.vue 의 .mobile-home-bar 가 대신한다.
    거기에는 로고만 있고, 눌러서 대시보드로 돌아가는 용도다 —
    제조사가 대시보드를 하단 탭에서 뺄 수 있기 때문이다.
  -->
  <header v-if="false" class="is-mobile-only mobile-header">
    <img src="@/assets/img/certilogo.png" class="logo-image" alt="CertiLife">
    <button
      type="button"
      class="menu-btn"
      ref="menuBtn"
      :aria-expanded="isDrawerOpen ? 'true' : 'false'"
      :aria-label="isDrawerOpen ? '메뉴 닫기' : '메뉴 열기'"
      @click="menuBtnFunction()"
    >
      <span></span>
    </button>
  </header>
  <aside
    id="new-sidenav"
    ref="newSideNav"
  >
    <!-- 계정 메뉴: 이름을 누르면 「내 계정 보안」(로그아웃 바로 위)·「로그아웃」. 메뉴 권한과 관계없이 모든 직원(U2).
         폰은 사이드바 대신 마이페이지에 같은 줄이 있음 -->
    <a-dropdown :trigger="['click']" placement="bottomLeft" :overlayStyle="{ minWidth: '180px' }">
      <button type="button" class="sidenav-userinfo-container sidenav-account-btn" aria-haspopup="menu">
        <img
          v-if="userInfo.imgUrl"
          :src="userInfo.imgUrl"
          class="user-logo"
          alt="main_logo"
        />
        <img
          v-else
          src="@/assets/img/profile_df.png"
          class="user-logo"
          alt="main_logo"
        />
        <div class="user-info-text">
          <div class="hospital-name">
            {{ userInfo.companyName }}
          </div>
          <div class="manager-name">
            {{ userInfo.username }}
          </div>
        </div>
        <DownOutlined class="sidenav-account-caret" />
      </button>
      <template #overlay>
        <a-menu @click="onAccountMenu">
          <a-menu-item v-if="!hideMySecurity" key="security">내 계정 보안</a-menu-item>
          <a-menu-item key="logout">{{ $t('navbar_signout') }}</a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>

    <sidenav-list 
      :menu="menu"
    />
    <div class="sidenav-footer-container">
      <div
        class="sidenav-item-container"
        @click="signOut"
      >
        <div class="sidenav-item-icon">
          <img src="@/assets/img/sidenav/signout.svg">
        </div>
        <div class="sidenav-item-text">
          {{ $t('navbar_signout') }}
        </div>
      </div>
    </div>
  </aside>
  <!-- 창 안 여백·닫기 줄은 인증번호 창과 같은 .otp-verify-modal 규칙 -->
  <a-modal v-model:open="mySecurityOpen" title="내 계정 보안" :width="560" :footer="null" centered
    destroyOnClose class="otp-verify-modal">
    <my-account-security />
    <div class="otp-footer"><a-button @click="mySecurityOpen = false">닫기</a-button></div>
  </a-modal>
</template>
<script>
import { locale } from 'dayjs';
import { DownOutlined } from '@ant-design/icons-vue';
import SidenavList from './SidenavList.vue';
import MyAccountSecurity from '@/views/components/MyAccountSecurity.vue';
import { signOut, oneBtnDialog, isMobileWidth } from '@/utils/utils';
import { blockedInSupportTab } from '@/utils/supportSession';
import { getProfile, isSupportTab } from '@/utils/tokenStore';

export default {
  name: 'index',
  components: {
    SidenavList,
    MyAccountSecurity,
    DownOutlined,
  },
  props: {
    class: {
      type: String,
    }
  },
  data() {
    return {
      // 지원 탭(서브 계정)엔 2FA 수단·비밀번호가 없어 「내 계정 보안」을 숨김(W6 C3)
      hideMySecurity: blockedInSupportTab('mySecurity', isSupportTab()),
      logo: '',
      company: '',
      manager: '',
      userInfo: {
        username: '',
        imgUrl: '',
        companyName: '',
        userId: '',
        locale: '',
      },
      menu: [],
      // 서랍이 열려 있는지. 실제 펼침은 #new-sidenav 의 .active 클래스가 하고,
      // 이 값은 버튼의 aria 상태와 화면 이동 시 닫기 판단에만 쓴다.
      isDrawerOpen: false,
      mySecurityOpen: false,
    };
  },
  computed: {
    computedUserInfo() {
      return this.$store.getters.getUserInfo;
    },
  },
  watch: {
    /**
     * 메뉴를 눌러 화면이 바뀌면 서랍을 닫는다.
     * 이게 없으면 서랍이 열린 채로 남아 이동한 화면을 가린다.
     */
    $route() {
      this.closeDrawer();
    },
    computedUserInfo: {
      handler(newValue, oldValue) {
        if(newValue.username) this.userInfo.username = newValue.username;
        if(newValue.imgUrl) this.userInfo.imgUrl = newValue.imgUrl;
        if(newValue.companyName) this.userInfo.companyName = newValue.companyName;
        if(getProfile('CompanyInfo')) {
          const companyInfo = JSON.parse(getProfile('CompanyInfo'));
          this.userInfo.companyName = companyInfo?.name;
          this.userInfo.imgUrl = companyInfo?.imgUrl;
        }
        if(newValue.userId) this.userInfo.userId = newValue.userId;
        // locale 동기화는 store mutation(setUserInfo)에서 i18n+localStorage까지 일원화 처리됨
        // 여기서는 컴포넌트 로컬 표시용 값만 업데이트
        if(newValue.locale){
          this.userInfo.locale = newValue.locale;
        }
        this.getSideNavContent();
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    async getSideNavContent() {
      try {
        // 가드와 같이 부르면 한 번만 읽음(ensurePrivileges — 실패는 그대로 던짐)
        await this.$store.dispatch('ensurePrivileges', this.userInfo.userId);
      } catch (error) {
        // PC 는 예전처럼 알린다. 폰은 하단 탭이 마이페이지만 남는 것으로 조용히 넘어간다.
        if (!isMobileWidth()) await oneBtnDialog('메뉴 로드 실패', '메뉴 로드에 실패했습니다.', false);
        return;
      }
      if(Array.isArray(this.$store.getters.getPrivilegesInfo.category)) {
        this.menu = this.$store.getters.getPrivilegesInfo.category
      }
    },
    handleResize(){
      if( window.innerWidth >= 768){
        this.$refs.newSideNav?.classList.remove("active")
        this.$refs.menuBtn?.classList.remove("active");
        // PC 폭으로 넓어지면 서랍 개념 자체가 없어진다. 상태도 같이 내려 둔다.
        this.isDrawerOpen = false;
      }
    },
    menuBtnFunction() {
      this.$refs.menuBtn?.classList.toggle("active");
      this.$refs.newSideNav?.classList.toggle("active")
      this.$refs.newSideNav?.classList.toggle("close");
      this.isDrawerOpen = !!this.$refs.newSideNav?.classList.contains("active");
      if(this.$refs.newSideNav?.classList.contains("close")){
        setTimeout(() => {
          this.$refs.newSideNav?.classList.remove("close")
        }, 500);
      }
    },
    /**
     * 서랍을 닫는다. 화면을 옮겼을 때와 창이 넓어졌을 때 쓴다.
     * 이미 닫혀 있으면 아무것도 하지 않는다 — 닫힘 애니메이션(.close)이 헛돌지 않게.
     */
    closeDrawer() {
      if (!this.$refs.newSideNav?.classList.contains("active")) return;
      this.menuBtnFunction();
    },
    /*
     * handleDeviceChange 를 지웠다.
     * `.navbar-vertical.navbar-expand-xs.fixed-start` 를 찾아 left 를 조절하던 함수인데,
     * 그 클래스는 이 프로젝트 마크업 어디에도 붙지 않는다(SCSS 선택자로만 남아 있다).
     * 늘 null 을 받아 아무 일도 하지 않았다. 서랍 펼침은 #new-sidenav 의 .active 가 담당한다.
     */
    // 실제 처리는 utils 의 signOut 에 있다. 마이페이지도 같은 함수를 쓴다 —
    // 두 벌로 갈라지면 한쪽만 고쳐지는 사고가 난다.
    async signOut() {
      await signOut({ i18n: this.$i18n, store: this.$store, router: this.$router });
    },
    onAccountMenu({ key }) {
      if (key === 'security') this.mySecurityOpen = true;
      else this.signOut();
    },
  },
};
</script>

<style scoped lang="scss">
/* 계정 메뉴 단추: 원래 머리 칸 모양 그대로 + 누를 수 있다는 표시(바탕·꺾쇠) */
#new-sidenav .sidenav-account-btn {
    width: 100%;
    gap: 10px;
    border: 0;
    border-radius: 0;
    background: transparent;
    font: inherit;
    text-align: left;
    cursor: pointer;
    &:hover, &.ant-dropdown-open { background: #f7f8f9; }
    &:focus-visible { outline: 2px solid #278aec; outline-offset: -2px; }
    .user-info-text { flex: 1; min-width: 0; width: auto; }
}
.sidenav-account-caret { flex: none; font-size: 12px; color: #4b5158; }

/*
 * 메뉴 버튼.
 *
 * 원래는 40×6px 노란 막대 세 개였는데, 50px 상단 바 안에서 지나치게 커 보였다.
 * 19×2px 짙은 막대로 줄이고 오른쪽에 둔다. 누르면 X 로 바뀌는 동작은 그대로 살린다.
 * 손가락 대상은 눈에 보이는 막대보다 넓게(34×34) 잡는다.
 */
.menu-btn {
    height: 34px;
    width: 34px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    display: grid;
    place-items: center;
    flex: none;
}

.menu-btn span {
    display: block;
    position: relative;
    width: 19px;
    height: 2px;
    border-radius: 2px;
    background: #1c1b1f;
    transition: background .2s ease-in-out;
}

.menu-btn span::before,
.menu-btn span::after {
    content: '';
    position: absolute;
    left: 0;
    width: 19px;
    height: 2px;
    border-radius: 2px;
    background: #1c1b1f;
    transition: transform .3s ease-in-out, top .3s ease-in-out;
}

.menu-btn span::before { top: -6px; }
.menu-btn span::after  { top: 6px; }

/* 열렸을 때 — 가운데 막대는 지우고 위아래를 X 로 겹친다 */
.menu-btn.active span { background: transparent; }
.menu-btn.active span::before { top: 0; transform: rotate(45deg); }
.menu-btn.active span::after  { top: 0; transform: rotate(-45deg); }
</style>